import React, {Component} from 'react';
import AsyncSelect from 'react-select/async';
import {devConsolelog} from '../../Utility';

export default class Autocomplete extends Component {
  state = { inputValue: null, selectData: [], inFocus: false };
  componentDidMount() {
    console.log('selectData didmount ', this.props.data);
    this.setState({selectData: this.props.data})

  }

  handleInputChange = (newValue= "") => {
    devConsolelog("handleInputChange ", newValue)
    // const inputValue = newValue
    // .replace(/\W/g, '');
    this.setState({ inputValue: newValue }, () => {
      devConsolelog("handleInputChange state set ", this.state.inputValue);
    });
    // return inputValue;
  };


  handleOnSelectFocus = () => {
    devConsolelog("handleOnSelectFocus ")
    this.setState({inputValue: null, inFocus: true}, () => {
      devConsolelog('handleOnSelectFocus state set ', this.state.inputValue, this.state.inFocus)
    });
  }

  selectOption = data => {
    devConsolelog('selectOption ', data, data && data.id);
    if(data) {
       // && data.id
      // this.setState({inputValue: data.name});
      this.props.onSearchReqSelect(data || null);
    }
    else this.props.onSearchReqSelect({name: null});
    // if(!data) data = {name: ""}
    // this.handleInputChange(data.name);
  }

  onSelectBlur = () => {
    devConsolelog('selectData chatSearch ', this.props.value)
    // if(this.props.value)
    // inputValue: this.props.value
    if(this.props.freetext) {
      console.log('autoComplete FREETEXT ', this.props.freetext, this.state.inputValue, this.props.value);
      let newData = {};
      newData[this.props.freetext || "name"] = this.state.inputValue
      this.props.onSearchReqSelect(newData || null);
    }
    this.setState({inFocus: false});
  }



  render() {
    devConsolelog('selectData chatSearch render ', this.state, this.props);
    let renderInputValue = this.props.value || "";
    // if(this.state.inputValue == null) renderInputValue = this.props.value || "";
    if(this.state.inFocus) renderInputValue = this.state.inputValue || "";

    let control = provided => (provided);
    if(this.props.setControlStyle) {
      control = provided => ({...provided, ...this.props.setControlStyle })
    }
    console.log('autoComplete setControlStyle ', renderInputValue, this.state, this.props.value );
// <div onFocusCapture={handleOnSelectFocus} onBlurCapture={onBlur}>
// options={this.state.selectData}
// value={this.props.value || ""}
    return (<AsyncSelect
      value={renderInputValue}
    //  isClearable={true}
      clearValue={this.props.clearValue || ''}
      placeholder={this.props.placeholder || ""}
      isSearchable={true}
      onChange={this.selectOption}
      onFocus={this.handleOnSelectFocus}
      onInputChange={this.handleInputChange}
      onBlur={this.onSelectBlur}
      menuPlacement={this.props.menuPlacement || "auto"}
      styles={{
        menu: provided => ({ ...provided, zIndex: 99999 }),
        control,
        indicatorsContainer: provided => ({...provided, display:'none'})
      }}
      defaultValue={this.props.defaultValue}
      defaultOptions={this.props.defaultOptions ? this.props.defaultOptions : true}
      loadOptions={this.props.promiseOptions}
    />)
  }

}
